// Test IDs for the admin CMS area (auth, dashboard, CRUD, leads, SEO, code).
export const ADMIN = {
  // shell
  layout: "admin-layout",
  nav: "admin-nav",
  logout: "admin-logout",
  // login
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  loginForgotLink: "admin-login-forgot-link",
  // forgot password (request a reset link)
  forgotPage: "admin-forgot-page",
  forgotEmail: "admin-forgot-email",
  forgotSubmit: "admin-forgot-submit",
  forgotSent: "admin-forgot-sent",
  forgotError: "admin-forgot-error",
  // reset password (set a new one via the emailed link)
  resetPage: "admin-reset-page",
  resetPassword: "admin-reset-password",
  resetConfirm: "admin-reset-confirm",
  resetSubmit: "admin-reset-submit",
  resetError: "admin-reset-error",
  resetSuccess: "admin-reset-success",
  resetInvalid: "admin-reset-invalid",
  // dashboard
  dashboard: "admin-dashboard",
  // collection manager
  list: "admin-list",
  newButton: "admin-new-button",
  editForm: "admin-edit-form",
  saveButton: "admin-save-button",
  deleteButton: "admin-delete-button",
  publishToggle: "admin-publish-toggle",
  // leads
  leadsTable: "admin-leads-table",
  leadSearch: "admin-lead-search",
  leadExport: "admin-lead-export",
  // seo
  seoForm: "admin-seo-form",
};
